import React from "react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";

import aboutImg from "../assests/aboutImg.webp";
import ShopByCategoryTitle from "./shopByCategoryTitle";

export const AboutUs: React.FC = () => {
  return (
    <Box sx={{ backgroundColor: "white", py: { xs: 6, md: 10 } }}>
      {/* Use full-width container, then center the inner content with a max width */}
      <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ maxWidth: 1200, mx: "auto" }}>
          <Grid
            container
            columnSpacing={{ md: 6, lg: 8 }}
            rowSpacing={{ xs: 5, md: 0 }}
            alignItems="start"
          >
            {/* LEFT COLUMN */}
            <Grid item xs={12} md={6}>
              <Typography
                component="h2"
                sx={{
                  fontFamily: `"Playfair Display", serif`,
                  fontWeight: 600,
                  color: "#0B0B0B",
                  letterSpacing: 0,
                  lineHeight: { xs: 1.05, md: 1.03 },
                  fontSize: { xs: "2rem", sm: "2.9rem", md: "4rem" },
                  whiteSpace: "pre-line",
                }}
              >
                {"ABOUT US"}
              </Typography>

              <Box sx={{ mt: { xs: 3, md: 8 }, maxWidth: 560 }}>
                <Typography
                  sx={{
                    color: "black",
                    fontSize: { xs: "0.88rem", md: "0.9rem" },
                    lineHeight: 1.7,
                    mb: 3,
                    width: { xs: "90%", md: "80%" },
                  }}
                >
                  We carefully select the finest materials precious metals,
                  sparkling gemstones, and luxurious pearls to create each
                  piece. Every design is meticulously crafted by skilled
                  artisans, ensuring that each item is not only beautiful but
                  built to last.
                </Typography>

                <Typography
                  sx={{
                    color: "black",
                    fontSize: { xs: "0.88rem", md: "0.9rem" },
                    lineHeight: 1.7,
                    mb: 3,
                    width: { xs: "90%", md: "80%" },
                  }}
                >
                  Our commitment to excellence is reflected in every detail,
                  from the intricate designs to the flawless finish. At Haroon
                  Sharif, we are dedicated to creating jewelry that transcends
                  trends, offering pieces that will remain cherished for
                  generations.
                </Typography>

                <Typography
                  sx={{
                    color: "black",
                    fontSize: { xs: "0.88rem", md: "0.9rem" },
                    lineHeight: 1.7,
                    width: { xs: "90%", md: "80%" },
                  }}
                >
                  Whether you&apos;re celebrating love, marking a special
                  occasion, or simply treating yourself, we invite you to
                  explore our collection and experience the celestial elegance
                  that defines us.
                </Typography>
              </Box>
            </Grid>

            {/* RIGHT COLUMN smaller image that ends near the left button */}
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  color: "black",
                  fontSize: { xs: "0.88rem", md: "0.9rem" },
                  lineHeight: 1.75,
                  maxWidth: 640,
                  mb: { xs: 2.5, md: 3 },
                  width: { xs: "90%", md: "80%" },
                }}
              >
                At Haroon Sharif, we believe that jewelry is more than just an
                accessory; it’s a timeless expression of elegance and a
                celebration of life’s most precious moments. With a legacy
                spanning over decades, our brand has become synonymous with
                exceptional craftsmanship and sophistication.
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-start" },
                  mt: { xs: 0.5, md: 1 },
                }}
              >
                <Box
                  component="img"
                  loading="lazy"
                  decoding="async"
                  src={aboutImg}
                  alt="Our craft"
                  sx={{
                    width: "100%",
                    maxWidth: { xs: 280, sm: 350, md: 390, lg: 450 },
                    maxHeight: { xs: 280, sm: 350, md: 390, lg: 450 },
                    height: "auto",
                    objectFit: "contain",
                    borderTopLeftRadius: "50%",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};
